"use client";

/**
 * Ensures compatibility with server components and prevents scolding from Next.js
 */

export * from "visionary-image";
